import { convertToSaveWaitlistDto, convertToWaitlist } from 'actions/waitlists/WaitlistsConverter';
import { WaitlistDto } from 'actions/waitlists/WaitlistsDtos';
import { convertToWaitlistError } from 'actions/waitlists/WaitlistsErrors';
import { ApiPublicClient, createTokenConfig } from 'api/ApiClient';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { SaveWaitlist, Waitlist } from 'types/Waitlist';

// POST /api/public/v1/waitlists, authenticated with the customer token.
const waitlistsUrl = 'waitlists';

export const createWaitlistThunk = (
    waitlist: SaveWaitlist
): ThunkAction<Promise<Waitlist>, RootState, null, RootAction> => {
    return async () => {
        try {
            const { data } = await ApiPublicClient.post<WaitlistDto>(
                waitlistsUrl,
                convertToSaveWaitlistDto(waitlist),
                createTokenConfig()
            );

            return convertToWaitlist(data);
        } catch (error) {
            console.error(error);

            throw convertToWaitlistError(error);
        }
    };
};
